import { render, staticRenderFns } from "./PlatformViewSponsors.vue?vue&type=template&id=4e0c0f9c&scoped=true&"
import script from "./PlatformViewSponsors.vue?vue&type=script&lang=js&"
export * from "./PlatformViewSponsors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0c0f9c",
  null
  
)

export default component.exports